import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { UserDto } from '../models/dto/user.dto';
import { TwoFactorAuthenticationDto } from '../models/dto/2fa.dto';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { StorageService } from './storage.service';
import { Constants } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private userProFile: UserDto;
  private is2FAEnabled: TwoFactorAuthenticationDto;

  constructor(
    private httpService: HttpService,
    private router: Router,
    private oidcSecurityService: OidcSecurityService,
    private storageService: StorageService
  ) { }

  async getUserProfileFromApi(): Promise<UserDto> {
    try {
      this.userProFile = await this.httpService.getUserProfile().toPromise();
    } catch (err: any) {
      if (err && err.status) {
        switch (err.status) {
          case 403:
            await this.router.navigate([Constants.qrAuthPage]);
            break;
          case 401:
            await this.router.navigate([Constants.loginPage]);
            break;
        }
      }
      this.userProFile = null;
    }
    return this.userProFile;
  }

  async isTwoFactorAuthenticationEnabledFromApi(): Promise<TwoFactorAuthenticationDto> {
    this.is2FAEnabled = await this.httpService.isTwoFactorAuthenticationEnabled().toPromise()
    return this.is2FAEnabled;
  }

  public async getUserProfile(): Promise<UserDto> {
    if (this.userProFile) {
      return this.userProFile;
    }
    return await this.getUserProfileFromApi();
  }

  public async isTwoFactorAuthenticationEnabled(): Promise<TwoFactorAuthenticationDto> {
    if (this.is2FAEnabled) {
      return this.is2FAEnabled;
    }
    return this.isTwoFactorAuthenticationEnabledFromApi();
  }

  isLoggedIn() {
    return this.oidcSecurityService.isAuthenticated$;
  }

  userData() {
    return this.oidcSecurityService.userData$;
  }

  token() {
    return this.oidcSecurityService.getAccessToken();
  }

  checkAuth() {
    return this.oidcSecurityService.checkAuthMultiple();
  }

  login() {
    this.oidcSecurityService.authorize();
  }

  async logout() {
    this.userProFile = null;
    this.storageService.setLogoutState();
    await lastValueFrom(this.oidcSecurityService.logoff());
  }
}
